import { uiGetters } from './getters/ui'
import { systemGetters } from './getters/system'
import { userGetters } from './getters/users'
import { groupGetters } from './getters/groups'
import { catalogGetters } from './getters/catalog'
import { trainingGetters } from './getters/trainings'
import { contentGetters } from './getters/content'
import { mediaGetters } from './getters/media'
import { boosterGetters } from './getters/boosters'
import { orderGetters } from './getters/orders'
import { promotionGetters } from './getters/promotions'
import { miscGetters } from './getters/misc'
import { commonGetters } from './getters/common'
import { tenancyGetters } from './getters/tenancy'

const getters = {
  ...uiGetters,
  ...systemGetters,
  ...userGetters,
  ...groupGetters,
  ...catalogGetters,
  ...trainingGetters,
  ...contentGetters,
  ...mediaGetters,
  ...boosterGetters,
  ...orderGetters,
  ...promotionGetters,
  ...miscGetters,
  ...commonGetters,
  ...tenancyGetters
}

export { getters }
